module.exports = __webpack_public_path__ + "static/media/product_detail_01.f3a0afe9.jpg";